export default function resolvePath(subPath: string) {
    return `${process.env.NEXT_PUBLIC_API_BASE_URL as string}${subPath}`;
}
